import { IExpression } from "@@expressions";
import { IComponent } from "./IComponent";
import { IconPlacement } from "./TypographyModel";

export type InputFieldModel = IComponent & {
  Label?: string;
  Value?: IExpression;
  DefaultValue?: IExpression;
  Placeholder?: string;
  Name?: string;
  Variant?: InputFieldVariant;
  IsRequired?: boolean;
  IsMultiLine?: boolean;
  DebunceMs?: number;
  IconName?: string;
  IconPlacement?: IconPlacement;
  IconColor?: string;
};

export enum InputFieldVariant {
  Standard = "Standard",
  Outlined = "Outlined",
  Filled = "Filled",
}

export { IconPlacement };



